import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '@env/environment';

export const nonProductionGuard: CanActivateFn = () => {
  if (environment.production) {
    return inject(Router).parseUrl('/not-found');
  }
  return true;
};
